import { Component, Entity, registerComponent } from "aframe";
import { Matrix4, Object3D, Quaternion, Vector3 } from "three";
import { projectFrom, transformVector, untransformPoint } from "../three/math";



interface HandMatrixComponent extends Component
{
	data : {
		hand : string;
		index : string;
		pinky : string;
		position : { x:number, y:number, z:number };
	}
}


const findObject = (parentEl : Entity, parentObj : Object3D | null, name : string) =>
{
	let obj : Object3D | undefined = undefined;
	if(parentObj)
	{
		if(parentObj.name == name)
			return parentObj;
		if((obj = parentObj.getObjectByName(name)))
			return obj;
	}

	for(let key in parentEl.object3DMap)
	{
		if((obj = parentEl.object3DMap[key].getObjectByName(name)))
			return obj;
	}

}

registerComponent("hand-matrix", {
	schema : {
		"hand" : { type : "string" },
		"index" : { type : "string" },
		"pinky" : { type : "string" },
		"position" : { type : "vec3" }
	},

	init(this : HandMatrixComponent)
	{
		this.el.addEventListener("object3dset", (event) => event.detail.type || this.update(null));
		this.el.addEventListener("parent-object-changed", (event) => this.update(null));
	},

	update(this : HandMatrixComponent)
	{
		const parentEl = this.el.parentEl!, parentObj = this.el.object3D.parent;
		const hand = findObject(parentEl, parentObj, this.data.hand);
		const index = findObject(parentEl, parentObj, this.data.index);
		const pinky = findObject(parentEl, parentObj, this.data.pinky);
		if(!(hand && index && pinky)) return;

		hand.updateWorldMatrix(true, false);
		index.updateWorldMatrix(true, false);
		pinky.updateWorldMatrix(true, false);

		const h = new Vector3(), i = new Vector3(), p = new Vector3();
		h.fromArray(hand.matrixWorld.elements, 12);
		i.fromArray(index.matrixWorld.elements, 12);
		p.fromArray(pinky.matrixWorld.elements, 12);

		const up = new Vector3(), forward = new Vector3(), outside = new Vector3();
		up.copy(i).sub(p); //Up goes from Pinky to Index
		forward.copy(i).sub(h); projectFrom(forward, up); //Forward goes from Hand to Index, and is perpendicular to Up
		outside.crossVectors(up, forward).divideScalar( Math.sqrt(outside.length()) ); //Outide is Inside cross Forward

		const pos = new Vector3(), rot = new Quaternion(), mat = new Matrix4();
		pos.copy(i); //Origin is Index position
		pos.addScaledVector(outside, this.data.position.x);
		pos.addScaledVector(up, this.data.position.y);
		pos.addScaledVector(forward, this.data.position.z);

		outside.normalize().toArray(mat.elements, 0); //X
		up.normalize().toArray(mat.elements, 4); //Y
		forward.normalize().toArray(mat.elements, 8);
		//rot.setFromRotationMatrix(mat);
		mat.decompose({} as Vector3, rot, {} as Vector3);

		if(parentObj)
		{
			const pq = new Quaternion();
			parentObj.updateWorldMatrix(true, false);
			//pq.setFromRotationMatrix(parentObj.matrixWorld);
			parentObj.matrixWorld.decompose({} as Vector3, pq, {} as Vector3)
			rot.premultiply(pq.conjugate());
			untransformPoint(pos, parentObj.matrixWorld);
		}

		this.el.object3D.quaternion.copy(rot);
		this.el.object3D.position.copy(pos);
	}


});